export default __webpack_public_path__ + "static/media/rage-of-the-sea.763dc05f.jpg";